<template>
    <v-layout d-flex column fill-height justify-center align-center>
        <v-spacer/>

        <v-layout d-flex column align-center shrink>
            <v-layout d-flex shrink align-center class="mb-10">
                <spoiled-logo :size="135" class="mt-8"/>

                <v-layout d-flex column align-center justify-start class="nocopy">
                    <v-flex class="appTitle triforce">
                        {{ appInfo.title }}
                    </v-flex>

                    <div class="subTitle triforce">{{ appInfo.subtitle }}</div>
                </v-layout>
            </v-layout>

            <v-flex shrink v-if="hasHistory" class="fileSelect mb-3">
                <spoiled-history/>
            </v-flex>
            <v-flex shrink class="fileSelect">
                <spoiled-upload/>
            </v-flex>
        </v-layout>

        <v-spacer/>

        <div class="subtext text--secondary mb-3 nocopy">{{ appInfo.version }}</div>
    </v-layout>
</template>

<script>
import SpoiledUpload from "@/components/base/SpoiledUpload";
import appInfo from "@/helper/appInfo";
import SpoiledLogo from "@/components/base/SpoiledLogo";
import SpoiledHistory from "@/components/base/SpoiledHistory";

export default {
    name: "SpoiledPortal",
    components: {SpoiledHistory, SpoiledLogo, SpoiledUpload},
    computed: {
        appInfo() {
            return appInfo.meta;
        },
        hasHistory() {
            return !!this.$store.getters['Log/history'].length;
        },
    },
}
</script>

<style scoped>
.appTitle {
    font-size: 9rem;
    font-weight: normal;
}

.subTitle {
    margin-top: -4.5rem;
    margin-left: 0;
}

.fileSelect {
  width: 20rem !important;
}
</style>